import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import { Menu} from 'antd';
import './Container.css';

const { SubMenu } = Menu;

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
	}
}

export const MenuContainer = 

// redux
connect(
	(mapStateToProps)
)(
	class extends Component {
		
		renderSubMenu(menu, backTo) {
			return (
				<SubMenu key={menu.id} title={menu.titulo}>
					{menu.submenus && menu.submenus.map (submenu => 
						<Menu.Item key={submenu.id}>
							{! submenu.linkExterno &&
								<Link to={{
									pathname: submenu.link,
									state: backTo ? { resetSearch: true, backTo } : { resetSearch: true }
								}}>{submenu.titulo}</Link>
							}
							{submenu.linkExterno &&
								<a rel="noopener noreferrer" target="_blank" href={submenu.link}>{submenu.titulo}</a>
							}
						</Menu.Item>
					)}
				</SubMenu>
			);
		}

		render() {
			const { user } = this.props;
			let itensMenu = [];
			if (user && user.menu.length > 0) {
				itensMenu = user.menu;
			}

			const todosSubmenus = [].concat(...itensMenu.map(menu => menu.submenus));
			const submenusGrandesVolumes = todosSubmenus.filter(submenu => submenu.grupo === "GRANDES_VOLUMES");
			const menusPrincipais = itensMenu.filter(menu =>
				menu.id !== "menu_grandes_volumes" &&
				!menu.submenus.some(submenu => submenu.grupo === "GRANDES_VOLUMES")
			);

			return (
				<Fragment>
					{(user && user.menu) && 
						<div className="menu-item" style={{width: "145px"}} >
							<Menu className="" mode="horizontal">
								<SubMenu key="sub_menu_administracao"
								title={
									<span className="submenu-title-wrapper">
									Administração
									</span>
								}
								>	
								<Menu.ItemGroup style={{ width: 350 }}>
									{menusPrincipais.map(menu => this.renderSubMenu(menu))}
									{submenusGrandesVolumes.length > 0 &&
										<SubMenu key="sub_menu_grandes_volumes_grupo" title="Grandes Volumes">
											{submenusGrandesVolumes.map(submenu =>
												<Menu.Item key={submenu.id}>
													{! submenu.linkExterno &&
														<Link to={{
															pathname: submenu.link,
															state: { resetSearch: true, backTo: "/grandes-volumes" }
														}}>{submenu.titulo}</Link>
													}
													{submenu.linkExterno &&
														<a rel="noopener noreferrer" target="_blank" href={submenu.link}>{submenu.titulo}</a>
													}
												</Menu.Item>
											)}
										</SubMenu>
									}
								</Menu.ItemGroup>
								</SubMenu>
							</Menu>
						</div>
					}
				</Fragment>
			);
		}

	}
	
); // redux